"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiFormControlStyles = void 0;
exports.muiFormControlStyles = {
    defaultProps: {
        size: 'small',
    },
    /*
     * styleOverrides: {
     *   root: {
     *     '&.MuiTextField-root': {
     *       width: '100%',
     *     },
     */
    /*
     *     '&.MuiTextField-root, &.MuiTextField-root *': {
     *       fontFamily: `${parseRSPToken('rsp.comp.textfield.input-text.font')} !important`,
     *     },
     */
    /*
     *     '&:focus-within .MuiInputLabel-shrink': {
     *       color: parseRSPToken('rsp.comp.textfield.focused.label-text.populated.color'),
     */
    /*
     *       '&.Mui-error': {
     *         color: parseRSPToken('rsp.comp.textfield.error-focused.label-text.populated.color'),
     *       },
     *     },
     *   },
     * },
     */
};
//# sourceMappingURL=form-control.js.map